import { render, staticRenderFns } from "./UpdateUser.vue?vue&type=template&id=05a23298&scoped=true"
import script from "./UpdateUser.vue?vue&type=script&lang=js"
export * from "./UpdateUser.vue?vue&type=script&lang=js"
import style0 from "./UpdateUser.vue?vue&type=style&index=0&id=05a23298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a23298",
  null
  
)

export default component.exports